import {Decoder, field, object} from 'json-bouncer'
import * as PrismaManufacturerStatus from './PrismaManufacturerStatus'
import * as PrismaRequestOffer from './PrismaRequestOffer'

export interface M {
    readonly prismaRequestOffer: PrismaRequestOffer.M
    readonly manufacturerStatus: PrismaManufacturerStatus.M
}

export function decoder(): Decoder<M> {
    return object({
        prismaRequestOffer:
            field('prismaRequestOffer', PrismaRequestOffer.decoder()),
        manufacturerStatus:
            field('manufacturerStatus', PrismaManufacturerStatus.decoder()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PrismaRequestOfferWithManufacturerStatus.ts